import { Truncate } from 'cpool-components/general/Truncate';
import { getAddedAdvisorId } from 'cpool-utils';
import { useTranslation } from 'react-i18next';
import { LuMessagesSquare } from 'react-icons/lu';

import type { AdvisorServiceLead } from './types';
import { useGetUserNameById } from '~/features/leadDetails/hooks/useGetUserNameById';
import { cn } from '~/utils/cnTailwind';

type Props = {
    className?: string;
    lead: AdvisorServiceLead;
};

export const AddedAdvisorLine: React.FC<Props> = ({ className, lead }) => {
    const { t } = useTranslation();
    const advisorId = getAddedAdvisorId(lead);
    const advisor = useGetUserNameById(advisorId ?? undefined);

    if (!advisorId) return null;

    const text = advisor ? `${advisor.firstName} ${advisor.lastName}` : t('LEADS.ADVISOR_SERVICE.ADVISOR_LINE_UNNAMED');

    return (
        <div
            className={cn('flex items-center gap-1 min-w-0 text-sm text-midnight', className)}
            data-testid="added-advisor-line"
        >
            <LuMessagesSquare
                aria-label={t('LEADS.ADVISOR_SERVICE.ADDED_ADVISOR_ICON')}
                className="size-4 shrink-0"
                role="img"
            />
            <Truncate className="min-w-0" text={text} />
        </div>
    );
};
